<template>
  <div>
    <div
      class="row"
      :style="rowStyle"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Row2',
  props: {
    rowStyle: { type: String, default: '' },
  },
};
</script>

<style scoped>
  .holder {
    background: white;
    padding: 14px;
  }
  .row {
    margin: -7px !important;
    margin-bottom: 14px;
  }
  .row > * {
    padding: 7px;
  }
</style>
